import { Icon } from 'antd';

const IconScriptUrl = '//at.alicdn.com/t/font_1455072_5tyihj8rtu3.js';
export const IconFont = Icon.createFromIconfontCN({
  scriptUrl: IconScriptUrl,
});
